<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.66602 13.0002H12.3327" stroke="#404A57" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M2.77668 7.79156C2.49243 8.07645 2.33275 8.46244 2.33268 8.86489V11.0002H4.48135C4.88402 11.0002 5.27002 10.8402 5.55468 10.5549L11.888 4.21822C12.1722 3.93329 12.3317 3.5473 12.3317 3.14489C12.3317 2.74248 12.1722 2.35649 11.888 2.07156L11.2627 1.44489C11.1217 1.30379 10.9542 1.19187 10.7699 1.11554C10.5856 1.0392 10.388 0.999938 10.1885 1C9.98905 1.00006 9.79153 1.03944 9.60727 1.1159C9.423 1.19235 9.25562 1.30437 9.11468 1.44556L2.77668 7.79156Z" stroke="#404A57" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script>
export default {
  name: 'IconResolveNote',
};
</script>

<style></style>

